module.exports = __webpack_public_path__ + "img/world.d476b0f5.png";